export const MobileValidation = /^\d{10}$/;
export const EmailValidation =
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const GSTValidation =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const POValidation = /^PO-\d{2}-\d{3,11}$/;
